<template>
  <div class="private-office">
    <router-view />
    <SearchBar />
    <div class="content--main">
      <div class="row">
        <div class="col-4 company--list-wrapper">
          <div class="company--list">
            <div v-for="(company, i) in companies" :key="i">
              <Widget
                :widgets="company"
                @widgetClick="handleWidgetClick"
                :class="i === 0 ? 'active' : ''"
              >
                <div v-if="company.userAvatar" class="widget--avatar">
                  <img :src="company.userAvatar" alt="user avatar" />
                </div>
                <div v-else class="widget--avatar">
                  <span>{{ company.companyName[0] }}</span>
                </div>
                <div class="widget--info">
                  <p class="mb-0">
                    {{ company.companyName }}
                  </p>
                  <p class="muted mb-0">
                    {{ company.members.length }} -
                    {{ company.members.length > 1 ? "members" : "member" }}
                  </p>
                </div>
              </Widget>
            </div>
          </div>
        </div>
        <div class="col-8 company--profile-wrapper">
          <div class="company--profile">
            <WidgetDetails
              :title="singlecompany.companyType"
              :widgetOptions="widgetOptions"
            >
              <div class="d-flex">
                <div v-if="singlecompany.userAvatar" class="widget--avatar">
                  <img :src="singlecompany.userAvatar" alt="user avatar" />
                </div>
                <div v-else class="widget--avatar">
                  <span>{{ singlecompany.companyName[0] }}</span>
                </div>
                <div class="widget--details-wrapper">
                  <h4>
                    {{ singlecompany.companyName }}
                  </h4>
                  <p class="-muted">
                    <img
                      src="~@/assets/media/icons/user.svg"
                      alt="company icon"
                      height="20"
                      width="20"
                    />{{ singlecompany.companyIndustry }} company
                  </p>
                  <div class="row">
                    <div class="col">
                      <p>
                        <img
                          src="~@/assets/media/icons/globe.svg"
                          alt="email icon"
                          height="20"
                          width="20"
                        />{{ singlecompany.companyEmail }}
                      </p>
                      <p>
                        <img
                          src="~@/assets/media/icons/call.svg"
                          alt="phone icon"
                          height="20"
                          width="20"
                        />{{ singlecompany.companyContact }}
                      </p>
                    </div>
                    <div class="col">
                      <p>
                        <img
                          src="~@/assets/media/icons/company.svg"
                          alt="email icon"
                          height="20"
                          width="20"
                        />{{ singlecompany.currentlyBooked }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="row align-items-end justify-content-between widget--table-row mx-0"
              >
                <div class="col px-0"><h4>Member</h4></div>
                <div class="col px-0 text-right">
                  <!-- <ActionButton
                    label="Add a member"
                    class="mt-0 d-inline-block w-auto"
                  /> -->
                  <ActionButton
                    label="Add a member"
                    class="mt-0 d-inline-block w-auto"
                    @customEvent="
                      handleAddCompanyMemberClick({
                        modal: 'admin-private-office-add-company-member',
                        name: 'add-company-member'
                      })
                    "
                  />
                </div>
              </div>
              <div class="row mx-0">
                <div class="col">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Position</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(member, i) in singlecompany.members" :key="i">
                        <td>{{ member.firstName }} {{ member.lastName }}</td>
                        <td>{{ member.position }}</td>
                        <td><a href="#">View member</a></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </WidgetDetails>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ActionButton from "@/components/ActionButton";
import SearchBar from "@/components/SearchBar";
import Widget from "@/modules/concierge/elements/Widget";
import WidgetDetails from "@/modules/concierge/elements/WidgetDetails";

export default {
  components: {
    SearchBar,
    Widget,
    WidgetDetails,
    ActionButton
  },
  data() {
    return {
      companies: [
        {
          companyEmail: "zaff.fadington@gmail.com",
          companyIndustry: "Tech",
          companyType: "Private Office",
          userAvatar: null,
          companyContact: "63 945 453 9381",
          companyName: "Explorer Limited",
          currentlyBooked: "Suite 100, 8th Floor - OCC",
          members: [
            {
              firstName: "Calvert",
              lastName: "Digby",
              position: "Chief people officer"
            },
            {
              firstName: "Manilo",
              lastName: "Crompton",
              position: "Culture operations manager"
            }
          ]
        },
        {
          companyEmail: "omen.kobe@gmail.com",
          companyIndustry: "Tech",
          companyType: "Private Office",
          userAvatar: "https://api.adorable.io/avatars/169/abott@adorable",
          companyContact: "63 971 333 8581",
          companyName: "Dreamedia",
          currentlyBooked: "Suite 90, 8th Floor - OCC",
          members: [
            {
              firstName: "Amina",
              lastName: "Acton",
              position: "Great Service Agent"
            }
          ]
        },
        {
          companyEmail: "holstein.skinner@gmail.com",
          companyIndustry: "Computer Services",
          companyType: "Private Office",
          userAvatar: "https://api.adorable.io/avatars/169/abott@adorable",
          companyContact: "63 944 473 0022",
          companyName: "Oakway",
          currentlyBooked: "Suite 900, 8th Floor - OCC",
          members: [
            {
              firstName: "Nara",
              lastName: "Rylan",
              position: "Second Tier Totalist"
            },
            {
              firstName: "Esther",
              lastName: "Merton",
              position: "Champagne Tester"
            },
            {
              firstName: "Gytha",
              lastName: "Oakley",
              position: "Digital Dynamo"
            }
          ]
        }
      ],
      singlecompany: [],
      activeIndex: 0,
      widgetOptions: [
        {
          icon: "edit",
          label: "Edit Details"
        },
        {
          icon: "delete",
          label: "Deactivate"
        }
      ]
    };
  },
  created() {
    this.singlecompany = this.companies[0];
  },
  methods: {
    ...mapActions({
      changeActiveTrail: "changeActiveTrail"
    }),
    handleWidgetClick(params) {
      const { e, widget } = params;
      this.singlecompany = widget;

      [...document.querySelectorAll(".widget")].map(e => {
        e.classList.remove("active");
      });
      e.target.closest(".widget").classList.add("active");
    },
    handleAddCompanyMemberClick(params) {
      const { modal, name } = params;
      this.$router.push({ name: modal, params: { modal, name } });
    }
  }
};
</script>

<style lang="scss" scoped>
.private-office {
  padding: 0 15px;
  .content--main {
    height: calc(
      100vh - 274px
    ); /* height of viewport minus the sum of nav.header and <SearchBar/> */
    overflow-x: hidden;
    overflow-y: auto;
    padding-bottom: 20px;
    padding-top: 20px;
    & > .row {
      height: 100%;
      div[class^="col-"] {
        height: 100%;
        overflow: auto;
      }
    }
    .company {
      &--list {
        border-radius: 5px;
      }
      &--profile {
        background-color: $gray-50;
        border-radius: 5px;
        max-height: 100%;
        overflow: auto;
        .widget--avatar {
          margin-right: 30px;
          span {
            align-items: center;
            background-color: $brand-primary;
            border-radius: 50%;
            color: $white;
            display: flex;
            font-family: "Gotham";
            font-size: $font-size-xl;
            font-weight: 500;
            height: 110px;
            justify-content: center;
            width: 110px;
          }
          img {
            border-radius: 50%;
            display: block;
            height: 110px;
            object-fit: cover;
            width: 110px;
          }
        }
        .widget--details-wrapper {
          h4 {
            color: $gray-900;
            font-size: $font-size-md;
            font-weight: 500;
            margin-bottom: 10px;
          }
          p {
            align-items: flex-start;
            display: flex;
            font-family: "Gotham Book";
            font-size: $font-size-sm;
            img {
              margin-right: 10px;
              height: 20px;
              width: 20px;
            }
            &.-muted {
              color: $gray-550;
            }
          }
        }
        .widget--table-row {
          border-bottom: 1px solid $gray-250;
          padding: 10px 0;
          h4 {
            color: $gray-900;
            font-size: $font-size-xs;
            font-weight: 500;
          }
        }
        .table {
          font-size: $font-size-xs;
          thead {
            th {
              color: $gray-900;
              font-weight: 500;
            }
          }
          tbody {
            td {
              color: $gray-900;
              font-family: "Gotham Book";
              &.member--status {
                font-family: "Gotham";
                font-weight: 600;
                letter-spacing: 1px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
